// components/getUserCount.js

import React, { useEffect, useState } from 'react';
import { collection, getCountFromServer } from 'firebase/firestore';
import { db } from '../firebase';

const GetUserCount = () => {
    const [userCount, setUserCount] = useState(0);

    useEffect(() => {
        const fetchUserCount = async () => {
            try {
                const coll = collection(db, 'users');
                const snapshot = await getCountFromServer(coll);
                setUserCount(snapshot.data().count);
            } catch (error) {
                console.error('Error fetching user count:', error);
            }
        };

        fetchUserCount();
    }, []);

    return <span>{userCount}</span>;
};

export default GetUserCount;
